import React from 'react'
import { PropagateLoader } from 'react-spinners'

const Loader = () => {
    return (
        <div className='flex-1 flex justify-center items-center'>
            <PropagateLoader color='#7FC241' size={20}/>
        </div>
    )
}

export default Loader